import z from 'zod';
export const currencyCodeModel = z.string().regex(/^[A-Z]{3}$/, 'Invalid currency code');
export const currencyAttributesModel = z.object({
    currencyCode: currencyCodeModel,
    decimalPrecision: z.number(),
    name: z.string(),
});
export const getCurrenciesApiResponseModel = currencyAttributesModel.array();
